import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util';
import { deleteAction, getAction, downloadFile } from '@/api/manage';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getBindingValue, getLargePermission } from "../utils/hasPermission";
export var JeecgListMixin = {
  data: function data() {
    return {
      permissionObj: {
        delete: '',
        deleteBatch: ''
      },
      dropDownVisible: false,
      //控制下拉菜单显隐（权限控制可用）
      //token header
      loadNums: 0,
      tokenHeader: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      dates: {},
      pagePath: '',

      /*页面基础路径*/
      pageTitle: '',

      /*页面功能名称*/

      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},

      /* 数据源 */
      dataSource: [],
      autoLoadInit: true,

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      /* 排序参数 */
      isorter: {// column: 'createTime',
        // order: 'desc',
      },

      /* 筛选参数 */
      filters: {},

      /* table加载状态 */
      loading: false,

      /* table选中keys*/
      selectedRowKeys: [],

      /* table选中records*/
      selectionRows: [],

      /* 查询折叠 */
      toggleSearchStatus: false,

      /* 高级查询条件生效状态 */
      superQueryFlag: false,

      /* 高级查询条件 */
      superQueryParams: '',
      searchCount: true
    };
  },
  created: function created() {
    //初始化字典配置 在自己页面定义
    this.initDictConfig();
    console.log('created-mixin', this.autoLoadInit);

    if (this.autoLoadInit) {
      this.loadData();
    }
  },
  methods: {
    // 按钮权限
    getAuth: function getAuth(id) {
      if (this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('tenant_admin')) {
        return true;
      } else {
        return id == this.$store.getters.userInfo.id;
      }
    },
    loadData: function loadData(arg) {
      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
          _this.loadNums++;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    initDictConfig: function initDictConfig() {// console.log("--这是一个假的方法!")
    },
    handleSuperQuery: function handleSuperQuery(arg) {
      //高级查询方法
      if (!arg) {
        this.superQueryParams = '';
        this.superQueryFlag = false;
      } else {
        this.superQueryFlag = true;
        this.superQueryParams = JSON.stringify(arg);
      }

      this.loadData();
    },
    getQueryParams: function getQueryParams() {
      //debugger
      //获取查询条件
      var sqp = {};

      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams);
      }

      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters);
      param.field = this.getQueryField(); // param.pageNo = this.ipagination.current
      // param.pageSize = this.ipagination.pageSize

      param.current = this.ipagination.current || this.queryParam.current;
      param.size = this.ipagination.pageSize || this.queryParam.size;
      param.searchCount = this.searchCount; // if(param.stime){
      // param.column = 'data_time'
      // param.order = 'desc'
      // }

      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      //TODO 字段权限控制
      var str = 'id,';
      this.columns.forEach(function (value) {
        if (value.dataIndex) {
          str += ',' + value.dataIndex;
        }
      });
      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    superQuery: function superQuery() {
      this.$refs.superQueryModal.show();
    },

    /*搜索重置按钮扩展方法*/
    searchResetImpl: function searchResetImpl() {},
    searchReset: function searchReset() {
      var queryParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var param = JSON.parse(JSON.stringify(this.queryParam));
      this.queryParam = _objectSpread({}, queryParam);

      if (param.scopeId && param.siteId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
        this.queryParam.siteId = param.siteId;
      } else if (param.scopeId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
      } else if (param.siteId) {
        this.queryParam.siteId = param.siteId;
      }

      this.dates = {};
      this.searchResetImpl();

      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    batchDel: function batchDel() {
      // if(!this.url.deleteBatch){
      //   this.$message.error("请设置url.deleteBatch属性!")
      //   return
      // }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            var headers = {};

            if (that.permissionObj.deleteBatch) {
              headers = {
                id: ids,
                tableName: that.permissionObj.deleteBatch.split(':')[1]
              };
              var largePermission = getLargePermission({
                value: that.permissionObj.deleteBatch
              });
              getBindingValue(headers, largePermission);
            }

            deleteAction(that.url && that.url.deleteBatch ? that.url.deleteBatch : that.pagePath + '/deleteBatch', {
              ids: ids
            }, headers).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleDelete: function handleDelete(id) {
      // if (!this.url.delete) {
      //   this.$message.error('请设置url.delete属性!')
      //   return
      // }
      var that = this;
      var headers = {};

      if (that.permissionObj.delete) {
        headers = {
          id: id,
          tableName: that.permissionObj.delete.split(':')[1]
        };
        var largePermission = getLargePermission({
          value: that.permissionObj.delete
        });
        getBindingValue(headers, largePermission);
      }

      deleteAction(that.url && that.url.delete ? that.url.delete : this.pagePath, {
        id: id
      }, headers).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          }); //this.queryParam = {}

          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handleEdit: function handleEdit(record) {
      //console.log(record)
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
      this.$refs.modalForm.edit(record);
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.add();
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //debugger
      //分页、排序、筛选变化时触发
      //TODO 筛选
      //debugger
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;

        if (sorter.column && sorter.column.colName) {
          this.isorter.column = sorter.column.colName;
        }

        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    modalFormOk: function modalFormOk() {
      this.searchReset(); // 新增/修改 成功时，重载列表

      this.loadData();
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.activeKey = '1';
      this.$refs.modalForm.showInput = false;
      this.$refs.modalForm.edit(record);
    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },

    /* 导出 */
    handleExportXls2: function handleExportXls2() {
      var paramsStr = encodeURI(JSON.stringify(this.getQueryParams()));
      var url = "".concat(window._CONFIG['domianURL'], "/").concat(this.url.exportXlsUrl, "?paramsStr=").concat(paramsStr);
      window.location.href = url;
    },
    handleExportXls: function handleExportXls(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, this.queryParam);

      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }

      var url = this.url && this.url.exportXlsUrl ? this.url.exportXlsUrl : this.pagePath + '/exportXls';
      downloadFile(fileName + '.xls', url, param);
    },

    /* 导入 */
    handleImportExcel: function handleImportExcel(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.$message.success("".concat(info.file.name, " \u6587\u4EF6\u4E0A\u4F20\u6210\u529F"));
          this.loadData();
        } else {
          this.$message.error("".concat(info.file.name, " ").concat(info.file.response.message, "."));
        }
      } else if (info.file.status === 'error') {
        this.$message.error("\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25: ".concat(info.file.msg, " "));
      }
    },

    /*选择导入文件*/
    handleImportFile: function handleImportFile() {
      //debugger
      var url = this.url && this.url.importExcelUrl ? this.url.importExcelUrl : this.pagePath + '/importExcel';
      return "".concat(window._CONFIG['domianURL']) + url;
    },

    /* 图片预览 */
    getImgView: function getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }

      return window._CONFIG['imgDomainURL'] + '/' + text;
    },

    /* 文件下载 */
    downUploadFile: function downUploadFile(text) {
      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }

      if (text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }

      window.open(window._CONFIG['domianURL'] + '/sys/common/download/' + text);
    }
  }
};